var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"font-weight-medium text--m"},[_vm._v(_vm._s(_vm.comment.employee_name))]),_c('span',{staticClass:"text--xs"},[_vm._v(_vm._s(_vm.comment.date_time))]),_c('p',{staticClass:"mt-1 mb-4 white-space"},[_vm._v(_vm._s(_vm.comment.comment))])])
}
var staticRenderFns = []

export { render, staticRenderFns }